import type { TransKeys } from '@/i18n/trans/index';
import { createTrans } from '@/i18n/trans/index';
import { Trans } from 'react-i18next';

export const TransAlert = createTrans({
  accountDeletionFailed: (
    <Trans
      i18nKey="alert.accountDeletionFailed"
      defaults="Account deletion failed."
    />
  ),
  accountSuccessfullyDeleted: (
    <Trans
      i18nKey="alert.accountSuccessfullyDeleted"
      defaults="Account successfully deleted."
    />
  ),
  bookingsSearchFailed: (
    <Trans
      i18nKey="alert.bookingsSearchFailed"
      defaults="Did not find a booking with this email and booking number. Please check the inserted data."
    />
  ),
  consentsNotAgreedWith: (
    <Trans
      i18nKey="alert.consentsNotAgreedWith"
      defaults="You must accept the mandatory consents in order to continue."
    />
  ),
  failedToRetrieveAvailableExtras: (
    <Trans
      i18nKey="alert.failedToRetrieveAvailableExtras"
      defaults="Failed to retrive available extras"
    />
  ),
  failedToSendPasswordResetLink: (
    <Trans
      i18nKey="alert.failedToSendPasswordResetLink"
      defaults="Failed to send password reset link."
    />
  ),
  fetchingBookingFailed: (
    <Trans
      i18nKey="alert.fetchingBookingFailed"
      defaults="Fetching booking information failed."
    />
  ),
  mandatoryFieldsMustBeFilled: (
    <Trans
      i18nKey="alert.mandatoryFieldsMustBeFilled"
      defaults='All fields must be filled, if not marked as "optional".'
    />
  ),
  mustAgreeWithToC: (
    <Trans
      i18nKey="alert.mustAgreeWithToC"
      defaults="You must agree with terms and conditions to continue."
    />
  ),
  passwordChangeFailed: (
    <Trans
      i18nKey="alert.passwordChangeFailed"
      defaults="Password change failed."
    />
  ),
  passwordResetLinkSentToEmail: (
    <Trans
      i18nKey="alert.passwordResetLinkSentToEmail"
      defaults="Password reset link sent to your email."
    />
  ),
  passwordSuccessfullyChanged: (
    <Trans
      i18nKey="alert.passwordSuccessfullyChanged"
      defaults="Password successfully changed."
    />
  ),
  paymentFailed: (
    <Trans i18nKey="alert.paymentFailed" defaults="Payment failed" />
  ),
  promoCodeApplied: (
    <Trans i18nKey="alert.promoCodeApplied" defaults="Promo code applied" />
  ),
  promoCodeNotApplied: (
    <Trans
      i18nKey="alert.promoCodeNotApplied"
      defaults="Promo code not applied. {{detail}}"
    />
  ),
  promoCodesDuringSearchHadNoEffect: (
    <Trans
      i18nKey="alert.promoCodesDuringSearchHadNoEffect"
      defaults="One or more promo codes applied during search had no effect"
    />
  ),
  purchaseCancellationFailed: (
    <Trans
      i18nKey="alert.purchaseCancellationFailed"
      defaults="Failed to cancel booking"
    />
  ),
  refundCancelled: (
    <Trans i18nKey="alert.refundCancelled" defaults="Refund cancelled" />
  ),
  refundFailed: (
    <Trans i18nKey="alert.refundFailed" defaults="Refund failed." />
  ),
  searchFormValidationFailed: (
    <Trans
      i18nKey="alert.searchFormValidationFailed"
      defaults="We couldn't start your search. Please check your details and try again."
    />
  ),
  somethingWentWrong: (
    <Trans
      i18nKey="alert.somethingWentWrong"
      defaults="Something went wrong. Please try again."
    />
  ),
  ancillaryRemovalFailed: (
    <Trans
      i18nKey="alert.ancillaryRemovalFailed"
      defaults="Failed to remove extra"
    />
  ),
  voucherApplied: (
    <Trans i18nKey="alert.voucherApplied" defaults="Voucher applied" />
  ),
  startExchangeFailed: (
    <Trans
      i18nKey="alert.startExchangeFailed"
      defaults="We couldn't start the booking modification. Please try again."
    />
  ),
});

export type TransAlertKeys = TransKeys<typeof TransAlert>;
